export default __webpack_public_path__ + "static/media/special-application-temp.f300b86a.JPG";